<template>
  <!-- Create Account Modal Structure -->
  <div id="create_account" class="modal services">
    <div class="modal-header">
      <a
        class="modal-close waves-effect btn-small waves-green right"
        v-if="attempt != '0'"
        >x</a
      >
      <!-- <img src="ui/img/logo.png" width="18%" class="responsive-img"> -->
    </div>
    <div class="modal-content">
      <h5>Create Account</h5>
      <p>
        Choose a password to secure your account and keep track of all your
        records for ease of access.
      </p>
      <div class="alert alert-warning">
        Password must contain at least one
        <strong
          >upper case (A-Z), one number (0-9) and minimum of 6
          characters.</strong
        >
      </div>
      <div class="row">
        <div class="input-field col s12 m12" v-if="reveal == true">
          <i
            class="material-icons prefix"
            @click="visibility"
            style="cursor: pointer;"
            >visibility_off</i
          >
          <input type="text" v-model="create.password" />
          <label for="password">Password</label>
        </div>
        <div class="input-field col s12 m12" v-if="reveal == false">
          <i
            class="material-icons prefix"
            @click="visibility"
            style="cursor: pointer;"
            >visibility</i
          >
          <input type="password" v-model="create.password" />
          <label for="password">Password</label>
        </div>
      </div>
      <div v-if="loading">
        <img src="ui/img/loading.svg" alt="Time Loader" />
        <p><i>Loading...</i></p>
      </div>
      <div class="row" v-else>
        <button
          id="createBtn"
          class="btn-large waves-effect green darken-2 waves-dark"
          style="width:100%;"
          @click.prevent="register"
        >
          Create Password
        </button>
      </div>
    </div>
  </div>
  <!-- Create Account Modal Structure -->
</template>
<script>
export default {
  props: ['attempt'],
  mounted() {
    this.initModal()
    if (localStorage.getItem('phone') !== null) {
      this.create.phone = localStorage.getItem('phone')
      this.create.signopt = 'user'
    }
  },
  data() {
    return {
      loading: false,
      reveal: false,
      create: {
        relocate: 'register',
        action: 'register',
        firstname: 'firstname',
        lastname: 'lastname'
      },
      modalInstance: {},
      updatedAttempt: ''
    }
  },
  methods: {
    register() {
      if (this.ValidateData()) {
        this.loading = true
        this.reveal = false
        // set form data
        var bodyFormData = new FormData()
        bodyFormData.set('relocate', this.create.relocate)
        bodyFormData.set('action', this.create.action)
        bodyFormData.set('phone', this.create.phone)
        bodyFormData.set('password', this.create.password)
        bodyFormData.set('repeat_password', this.create.password)
        bodyFormData.set(
          'email',
          this.create.phone + '@' + this.create.phone + '.com'
        )
        bodyFormData.set('firstname', this.create.firstname)
        bodyFormData.set('lastname', this.create.lastname)
        bodyFormData.set('signopt', this.create.signopt)
        this.axios
          .post('control1.php', bodyFormData)
          .then(response => {
            if (response.data.status == 1) {
              $('.toast').hide()
              this.loading = false
              localStorage.setItem('user', true)
              localStorage.removeItem('attempts')
              this.modalInstance[6].close()
              this.modalInstance[5].close()
            } else {
              this.loading = false
              $('.toast').hide()
              M.toast({ html: response.data.message, classes: 'info' })
            }
          })
          .catch(error => {
            $('.toast').hide()
            M.toast({
              html: 'Could not send request, check network.',
              classes: 'error'
            })
            this.loading = false
          })
      }
    },
    visibility() {
      this.reveal = !this.reveal
    },
    ValidateData() {
      if (this.create.password) {
        return true
      } else {
        $('.toast').hide()
        M.toast({ html: 'Password field is required!', classes: 'info' })
      }
    },
    initModal() {
      // initialize modal for the document
      const option = { dismissible: false, preventScrolling: true }
      var elems = document.querySelectorAll('.modal.services')
      var instances = M.Modal.init(elems, option)
      this.modalInstance = instances
    }
  }
}
</script>
<style scoped>
.modal .modal-content {
  padding: 0px 24px;
}
.modal.services {
  transform: translate(0%, -50%) !important;
  width: 42%;
  top: 50% !important;
}
@media screen and (max-width: 600px) {
  .modal.services {
    transform: translate(0%, -50%) !important;
    width: 100%;
    top: 50% !important;
  }
}
.alert-warning {
  color: #856404;
  background-color: #fff3cd;
  border-color: #ffeeba;
}

.alert {
  position: relative;
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.25rem;
}
</style>
